<template>
  <div>
    <div class="col align-self-center text-center " v-if="loading">
      <clip-loader />
    </div>
    <div v-else>
      <HomeArticle v-for="(article, index) in articles"
        v-bind:key="article.id" v-bind:enhance="!(index % 2)"
        v-bind:article="article.data"/>
    </div>
  </div>
</template>

<script>
import { client, filter } from '../prismic';
import HomeArticle from './Article.vue';
import ClipLoader from './ClipLoader.vue';

export default {
  name: 'Articles',
  components: { HomeArticle, ClipLoader },
  data() {
    return {
      articles: [],
      loading: true,
    };
  },
  methods: {
    getContent() {
      client.get({
        filters: [filter.at('document.tags', ['accueil'])],
        pageSize: 100,
      })
        .then((response) => {
          this.articles = response.results
            .sort((a, b) =>
              a.data.article_date && b.data.article_date &&
              new Date(b.data.article_date).getTime() - new Date(a.data.article_date).getTime());
          this.loading = false;
        });
    },
  },
  created() {
    this.getContent();
  },
};
</script>
